export const ARCHIVE_CREATE_SYSTEM_JOB_NAME = "org.graylog.plugins.archive.job.ArchiveCreateSystemJob";
export const ARCHIVE_LICENSE_WARNING_TITLE = "license_warning.title";
export const ARCHIVE_LICENSE_WARNING_TEXT = "license_warning.text";
